import styled from 'styled-components';

export const Wrapper = styled.div<{
  $flexDirection?: string;
  $mobileDirection?: string;
  $tabletDirection?: string;
}>`
  display: flex;
  gap: 0.75rem;
  flex-direction: ${(props) =>
    props.$flexDirection ? props.$flexDirection : 'column'};

  @media screen and (max-width: 768px) {
    flex-direction: ${(props) =>
      props.$tabletDirection ? props.$tabletDirection : 'column'};
  }

  @media screen and (max-width: 431px) {
    flex-direction: ${(props) =>
      props.$mobileDirection ? props.$mobileDirection : 'column'};
  }
`;

export const ImageWrapper = styled.div<{
  $aspectRatio: number;
  $width?: string;
  $mobileWidth?: string;
  $tabletWidth?: string;
  $maxWidth?: string;
  $maxLgWidth?: string;
}>`
  aspect-ratio: ${(props) => props.$aspectRatio};
  position: relative;
  width: ${(props) => props.$width};
  max-width: ${(props) => props.$maxWidth};

  overflow: hidden;
  // background-color: rgb(209, 209, 209);

  @media screen and (max-width: 1024px) {
    max-width: ${(props) =>
      props.$maxLgWidth ? props.$maxLgWidth : props.$maxWidth};
  }

  @media screen and (max-width: 768px) {
    width: ${(props) => (props.$tabletWidth ? props.$tabletWidth : '100%')};
    max-width: unset;
  }

  @media screen and (max-width: 431px) {
    width: ${(props) => (props.$mobileWidth ? props.$mobileWidth : '100%')};
    max-width: unset;
  }
`;

export const ImageHoverWrapper = styled.div`
  transform: scale(1);
  transition: transform 0.3s ease-in-out;
  height: 100%;
  &:hover {
    transform: scale(1.1);
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.75rem;
`;

export const ContentSkeletonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  width: 100%;
`;

export const TitleSkeletonWrapper = styled.div`
  min-height: 3rem;
`;

export const StyledDescription = styled.h4<{
  $whiteText?: boolean;
}>`
  font-size: 0.813rem;
  font-weight: 400;
  text-align: left;
  color: ${(props) => (props.$whiteText ? '#FFF' : '#67708C')};
  width: 100%;
  margin: 0;
`;

export const StyledTitle = styled.h3<{
  $whiteText?: boolean;
  $loading?: boolean;
}>`
  font-weight: 700;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
  color: ${(props) => (props.$whiteText ? '#FFF' : '#1E242F')};
  margin: 0;
  min-height: 3.5rem; /* Adjust based on your line height */
  text-overflow: ${(props) => (props.$loading ? 'unset' : 'ellipsis')};
`;

export const SocialIconsWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  overflow: hidden;
`;
